import React from 'react';
import SarasTooltip from '../../notifications/SarasTooltip';
import SarasTrans from '../../notifications/SarasTrans';

const FormROStatus = (props) => {
    const { formObject, compactMode, action, rowKey, headerKey, format, className, ...restProps } = props;

    const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
    const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");

    const getValue = () => {
        let value = formObject.getValueFromKey(viewData, "dataList.valS", viewData.valF || viewData.val);

        return {val: viewData.val, valF: <SarasTrans value={value} />};
    }

    const getStyle = () => {
        if (viewData.dataList && viewData.dataList.colCssStyle && viewData.dataList.colCssStyle !== "") {
            return JSON.parse(viewData.dataList.colCssStyle)
        }
        else {
            return {}
        }
    }

    if (viewData && hide === "0") {
        let displayValue = getValue();

        return (
            <SarasTooltip title={displayValue.valF}>
                <span className={`${className} ${compactMode ? 'uiStatusCompact' : 'uiChip'} ${viewData.dataList ? viewData.dataList.colCssClass : ''}`} 
                        style={getStyle()} {...restProps}>{compactMode ? '' : displayValue.valF}</span>
            </SarasTooltip>
        )
    }

    return (null);
}

export default FormROStatus